module.exports = __webpack_public_path__ + "img/flag-UY.fda61647.svg";